import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { RegistrationData } from "../widget.model";

@Component({
  selector: "step-three",
  templateUrl: "./step-three.component.html",
})
export class StepThreeComponent implements OnInit {
  @Input() errorPatientExist: boolean;
  @Input() errorNotExist: boolean;
  @Input() selectedLanguageIsoCode: string;
  registerTabSelected: boolean;
  loginTabSelected: boolean;

  @Output() sendPersonInfo = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  sendRegistrationData(patientRegistrationData: RegistrationData) {
    this.sendPersonInfo.next({
      type: "registration",
      firstName: patientRegistrationData.firstName,
      lastName: patientRegistrationData.lastName,
      birthDate: patientRegistrationData.birthDate,
      communicationChannels: [
        {
          id: null,
          typeId: "6a21617c-d92d-4784-ad3c-2a62861e6500",
          content: patientRegistrationData.telNumber,
          label: "mobile-phone",
        },
        {
          id: null,
          typeId: "c41eddc2-827e-47de-9502-06ad7cfcea4e",
          content: patientRegistrationData.email,
          label: "email",
        },
      ],
    });
  }

  sendLoginData(patientRegistrationData: RegistrationData) {
    this.sendPersonInfo.next({
      type: "login",
      communicationChannels: [
        {
          id: null,
          typeId: "c41eddc2-827e-47de-9502-06ad7cfcea4e",
          content: patientRegistrationData.email,
          label: "email",
        },
      ],
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/strahinja.aparac/Desktop/git/source/healthcare/v2/app/appointment-widget/src/app/step-three/step-three.component.ts